export const ERROR = 'ERROR'

export const LOADING = 'LOADING'

export const LOADING_OFF = 'LOADING_OFF'

export const LOG_IN = 'LOG_IN'

export const LOGOUT = 'LOGOUT'

